import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  elevatedSurfaceBoxShadow,
  fullsizeAbsolute,
} from '../../../../shared/style-settings'

const cardRadius = 16

export const useMainPageImpactMetricCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      borderRadius: cardRadius,
      overflow: 'hidden',
      backgroundColor: theme.palette.common.white,
      boxShadow: elevatedSurfaceBoxShadow,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    imageWrap: {
      position: 'relative',
      width: '100%',
      paddingTop: '56%',
      overflow: 'hidden',
      backgroundColor: theme.palette.grey[200],
    },
    image: {
      ...fullsizeAbsolute,
      objectFit: 'cover',
    },
    body: {
      padding: theme.spacing(3, 2.75, 3.25),
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    value: {
      margin: 0,
      marginBottom: theme.spacing(1.25),
      fontWeight: 800,
      fontSize: 'clamp(1.75rem, 2.5vw, 2.35rem)',
      lineHeight: 1.1,
      letterSpacing: '-0.03em',
      color: theme.palette.primary.main,
    },
    label: {
      margin: 0,
      fontSize: 'clamp(0.875rem, 1.15vw, 1rem)',
      lineHeight: 1.55,
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
  })
)
